import { HousingInfo } from "../../models/housing-info";
import { PersonalDataInfo } from "../../models/personal-data-info";
import { InitialQuotation } from "../../models/initial-quote";
import { GuessPriceInfo } from "../../models/guess-price-info";
import { PaymentInfo } from "../../models/payment-info";
import { AddressInfo } from "../../models/address-info";
import { PARTNER_TYPE } from "../../constants/datalayer";

const homeInsuranceInitialState = {
    landing: {
        calculator: {
            submitting: false,
            error: null,
            calculateTimes: 0,
            calculatedPrice: 0,
            ubigeo: null,
            squareMeters: null,
            housingType: null,
        },
        whoCanHire: {
            modal: {
                opened: false,
            },
        },
    },
    quotation: {
        requestId: null,
        price: 0,
        propertyInsuranceHasMinPrime: false,
        belongingsInsuranceHasMinPrime: false,
        hasMainPrimeMinPrime: false,
        hasRobberyPrimeMinPrime: false,
        initialQuotationForm: {
            documentNumberValidation: {
                exists: true,
                loading: false,
            },
            submitting: false,
            error: null,
            data: new InitialQuotation(),
            done: false,
        },
        personalDataForm: {
            submitting: false,
            error: null,
            data: new PersonalDataInfo(),
            done: true,
        },
        housingInfoForm: {
            submitting: false,
            error: null,
            data: new HousingInfo(),
            done: false,
        },
        addressInfoForm: {
            submitting: false,
            error: null,
            data: new AddressInfo(),
            done: false,
        },
        guessPriceForm: {
            submitting: false,
            error: null,
            data: new GuessPriceInfo(),
            done: false,
        },
        customPlanView: {
            submitting: false,
            fixedPlan: {
                declaredBelongingsAmount: null,
                declaredPropertyAmount: null,
            },
            done: false,
        },
        paymentForm: {
            totalPrice: 0,
            totalPriceWithDiscount: 0,
            submitting: false,
            error: null,
            data: new PaymentInfo(),
            done: false,
        },
        paymentResult: {
            policyNumber: null,
            payDate: null,
            endDate: null,
        },
        mainCoverage: null,
        selectedCoverages: [],
        disabledCoverages: [],
        assistantPackage: null,
        propertyData: { submitting: false },
    },
    ubigeos: null,
    ubigeoMap: null,
    recommendedCoverages: {
        addedToList: false,
        showLabel: true,
    },
    coverages: [],
    fixedCoverages: [],
    paymentFees: [],
    assistantPackage: null,
    coverageInfoModal: {
        coverageCode: null,
        variant: null,
        opened: false,
    },
    lazyComponents: {
        quotePopup: {
            isLoadRequested: false,
            isLoadSuccess: false,
            loadSuccessCounter: 0,
        },
        preloadComponents: {
            isLoadRequested: false,
            isLoadSuccess: false,
        },
    },
    channel: {
        partner: PARTNER_TYPE.default,
        partnerType: PARTNER_TYPE.default,
        uaCode: "",
        chatShowed: false,
        phoneShowed: false,
        submitting: false,
        idZoho: "",
    },
    securitySystemModal: {
        opened: false,
    },
    activePromotion: null,
    activePromotionDone: false,
    isCustomerDocumentIdInvalid: false,
    crmOracle: {
        partyId: null,
        optyNumber: null,
        done: false
    },
};

export default homeInsuranceInitialState;
